import React from "react";
import PromoCards from "../Components/PromoCards/PromoCards";
import Categories from "../Components/Categories/Categories";
import ProductCard from "../Components/ProductCard/ProductCard";
import FeaturedProducts from "../Components/ProductCard/FeaturedProducts";
import HomePageFive from "../Components/HomePageFive/HomePageFive";
import Team from "../Components/Team/Team";
import Testimonial from "../Components/Testmonial/Testimonial";
// import LogoCarousel from "../Components/LogoCarousel/LogoCarousel";
import HomeBanner from "../Components/HomePageBanner/HomePageBanner";
import HomePageBannerFeature from "../Components/HomePageBannerFeature/HomePageBannerFeature";
import ProductGrid from "../Components/ProductSectionTwo/ProductGrid";
import Navbar from "../Components/Navbar/nav";
import Topbar from "../Components/Topbar/Topbar";
import MiddleBar from "../Components/MiddleBar/MiddleBar";
import Footer from "../Components/Footer/Footer";
import Copyrights from "../Components/Copyrights/Copyright";
import Newsletter from "../Components/NewsLetter/Newletter";

const Home = () => {
  return (
    <>
      <Topbar />
      <MiddleBar />
      <Navbar />
      <HomeBanner />
      <HomePageBannerFeature />
      <PromoCards />
      <Categories />
      <ProductCard />
      <FeaturedProducts />
      <ProductGrid />
      <HomePageFive />
      <Team />
      <Testimonial />
      {/* <LogoCarousel /> */}
      <Newsletter />
      <Footer />
      <Copyrights />
    </>
  );
};

export default Home;
